import React from 'react';
import { ButtonStyled } from './style';
import { useLoginContext } from 'context/login-context';

interface ButtonLoginProps {
    label: string;
    onClick: (event?) => void;
    id: string;
    disabled?: boolean;
    icon?: any;
    margin?: string;
    alignSelf?: string;
    type?: 'with-icon' | 'no-icon';
}

const ButtonLogin = ({
    label,
    onClick,
    id,
    disabled = false,
    icon,
    margin,
    alignSelf,
    type = 'no-icon',
}: ButtonLoginProps) => {
    const { isLoading } = useLoginContext();

    return (
        <ButtonStyled
            id={id}
            type='submit'
            onClick={onClick}
            disabled={disabled}
            className={type}
            margin={margin}
            alignSelf={alignSelf}
            isLoading={isLoading}
        >
            {label}
            {icon && icon}
        </ButtonStyled>
    )
}

export default ButtonLogin;